import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import TypePageConstant from "./TypePageConstant";
import helperSpinner from "../../../helpers/spinner";
import helperNumber from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import StatePageConstant from "./StatePageConstant";

export default function ViewInfoPageSitePublisher() {
  const params = useParams();
  const pageID = parseInt(params.pageID);
  const [page, setPage] = useState();
  const [urlSitePublisher, setUrlSitePublisher] = useState();

  useEffect(() => {
    getPage();
  }, []);

  useEffect(() => {
    if (!page) {
      return;
    }
    getUrlSitePublisher();
  }, [page]);

  const getUrlSitePublisher = () => {
    let pageLink = page.link.replace("https://", "");
    if (pageLink.slice(-1) != "/") {
      pageLink = pageLink + "/";
    }
    const urlSitePublisher = pageLink.split("/")[0];
    setUrlSitePublisher(urlSitePublisher);
  };

  const getPage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultSendRequestGetPage = await sendRequestGetPage(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetPage) {
      return;
    }

    setPage(resultSendRequestGetPage);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPage = async () => {
    const headersRequest = getHeaderRequest();
    let page;
    try {
      page = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return page.data.data;
  };

  const generateMessageAdminForRejectPage = () => {
    if (
      page.state == StatePageConstant.statusSiteUserPublisher.REJECT ||
      page.state == StatePageConstant.statusSiteUserPublisher.REJECT_EDIT
    ) {
      return (
        <div className="alert alert-danger">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            دلیل رد شدن صفحه :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>{page.message}</p>
            </li>
          </ul>
        </div>
      );
    }
    return <></>;
  };

  const checkPageStateIsPendingEditOrRejectEdit = () => {
    if (
      page.state == StatePageConstant.statusSiteUserPublisher.PENDING_EDIT ||
      page.state == StatePageConstant.statusSiteUserPublisher.REJECT_EDIT
    ) {
      return true;
    }
    return false;
  };

  const generateTemporaryDateEditPage = () => {
    if (!checkPageStateIsPendingEditOrRejectEdit()) {
      return <></>;
    }

    return (
      <div className="pt-3">
        <div className="alert alert-warning">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>
                این اطلاعات صفحه است که توسط شما وارد شده و شما قصد ویرایش صفحه
                این را داشتید.
              </p>
            </li>
          </ul>
        </div>
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات صفحه ویرایش شده{" "}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره صفحه</td>
                <td>{page.temporary.id}</td>
              </tr>
              <tr>
                <td>عنوان صفحه</td>
                <td>
                  {page.temporary.title}
                  {page.temporary.pattern_url.includes("/@s") ? (
                    <span className="pr-2">
                      <span className="badge badge-success">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.MULTI_PAGE
                          ]
                        }
                      </span>
                    </span>
                  ) : (
                    <span className="pr-2">
                      <span className="badge badge-warning">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.STATIC
                          ]
                        }
                      </span>
                    </span>
                  )}
                </td>
              </tr>
              <tr>
                <td>نوع صفحه</td>
                <td>
                  {page.temporary.pattern_url.includes("@s")
                    ? TypePageConstant.typePageString()[
                        TypePageConstant.typePage.MULTI_PAGE
                      ]
                    : TypePageConstant.typePageString()[
                        TypePageConstant.typePage.STATIC
                      ]}
                </td>
              </tr>
              <tr>
                <td>الگوی آدرس</td>
                <td className="text-left ltr">{page.temporary.pattern_url}</td>
              </tr>
              <tr>
                <td>لینک</td>
                <td className="text-left ltr">
                  <span>{page.temporary.link}</span>
                  <span className="pl-2">
                    <a
                      className="btn btn-primary"
                      target="_blank"
                      href={page.temporary.link}
                    >
                      <i className="fa fa-link"></i>
                    </a>
                  </span>
                </td>
              </tr>

              <tr>
                <td>حالت</td>
                <td>
                  <div dir="ltr">
                    {page.temporary.active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </div>
                </td>
              </tr>

              <tr>
                <td>عکس صفحه</td>
                <td>
                  <a
                    target="_blank"
                    href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page.temporary.img_name}`}
                  >
                    <img
                      className="border border-success img-fluid"
                      src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page.temporary.img_name}`}
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const generatePageInfo = () => {
    let classBadgeStatePage;
    switch (page.state) {
      case StatePageConstant.statusSiteUserPublisher.PENDING:
        classBadgeStatePage = "badge-warning";
        break;
      case StatePageConstant.statusSiteUserPublisher.CONFIRM:
        classBadgeStatePage = "badge-info";
        break;
      case StatePageConstant.statusSiteUserPublisher.REJECT:
        classBadgeStatePage = "badge-danger";
        break;
      case StatePageConstant.statusSiteUserPublisher.REJECT_EDIT:
        classBadgeStatePage = "badge-danger";
        break;
      case StatePageConstant.statusSiteUserPublisher.PENDING_EDIT:
        classBadgeStatePage = "badge-warning";
        break;
    }
    return (
      <>
        <div className="text-left pb-2">
          <Link
            className="btn btn-primary"
            to={`/page/all/publisher/${page?.web_site_publisher_id}`}
          >
            <span>بازگشت</span>
            <span className="pr-2">
              <i className="fas fa-arrow-left"></i>
            </span>
          </Link>
        </div>
        {generateMessageAdminForRejectPage()}
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات صفحه{" "}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره صفحه</td>
                <td>{page.id}</td>
              </tr>
              <tr>
                <td>عنوان صفحه</td>
                <td>
                  {page.title}
                  {page.pattern_url.includes("/@s") ? (
                    <span className="pr-2">
                      <span className="badge badge-success">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.MULTI_PAGE
                          ]
                        }
                      </span>
                    </span>
                  ) : (
                    <span className="pr-2">
                      <span className="badge badge-warning">
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.STATIC
                          ]
                        }
                      </span>
                    </span>
                  )}
                </td>
              </tr>
              <tr>
                <td>نوع صفحه</td>
                <td>
                  {page.pattern_url.includes("@s")
                    ? TypePageConstant.typePageString()[
                        TypePageConstant.typePage.MULTI_PAGE
                      ]
                    : TypePageConstant.typePageString()[
                        TypePageConstant.typePage.STATIC
                      ]}
                </td>
              </tr>
              <tr>
                <td>الگوی آدرس</td>
                <td className="text-left ltr">{page.pattern_url}</td>
              </tr>
              <tr>
                <td>لینک</td>
                <td className="text-left ltr">
                  <span>{decodeURI(page.link)}</span>
                  <span className="pl-2">
                    <a
                      className="btn btn-primary"
                      target="_blank"
                      href={page.link}
                    >
                      <i className="fa fa-link"></i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span className={`badge ${classBadgeStatePage}`}>
                    {page.state}
                  </span>
                </td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  <div dir="ltr">
                    {page.active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helperNumber.toPersianNum(
                    page.created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        page.created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
              <tr>
                <td>عکس صفحه</td>
                <td>
                  <a
                    target="_blank"
                    href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page.img_name}`}
                  >
                    <img
                      className="border border-success img-fluid"
                      src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page.img_name}`}
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          {page["temporary"] && generateTemporaryDateEditPage()}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`${page?.title}  در سایت ${urlSitePublisher}`} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{page && generatePageInfo()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
